import useVideoContext from '../useVideoContext/useVideoContext';
import useDominantSpeaker from '../useDominantSpeaker/useDominantSpeaker';
import useParticipants from '../useParticipants/useParticipants';
import useScreenShareParticipant from '../useScreenShareParticipant/useScreenShareParticipant';
import useSelectedParticipant from '../../components/VideoProvider/useSelectedParticipant/useSelectedParticipant';
import type { AgoraParticipantLike } from '../../types';
import { sameAgoraParticipant } from '../../utils/sameAgoraParticipant';

export default function useMainParticipant(): AgoraParticipantLike | null {
  const [selectedParticipant] = useSelectedParticipant();
  const screenShareParticipant = useScreenShareParticipant();
  const dominantSpeaker = useDominantSpeaker();
  const participants = useParticipants();
  const { room } = useVideoContext();
  const localParticipant = room?.localParticipant ?? null;

  return (
    selectedParticipant ||
    // In speaker view, the main tile should be the screen-share whenever anyone (including you) is sharing.
    screenShareParticipant ||
    dominantSpeaker ||
    participants[0] ||
    localParticipant ||
    null
  );
}
